import React from 'react';
import {FmlxButton} from 'fmlx-common-ui';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {LabelBar, ButtonBar} from '../../components';
import HeaderLayout from '../../components/Layout/HeaderLayout';

function mapStateToProps(state) {
  return {
    reportState: state.reportState,
  };
}

class DispenseReportHeader extends React.PureComponent {
  render() {
    const {intl, onDownloadClick, onPrintClick, onBack, reportState} = this.props;

    return (
      <HeaderLayout>
        <HeaderLayout.Left>
          <ButtonBar onClick={onBack}>
            <div className="image-button">
              <img src="./svg/set-tip/icon-back.svg" alt="Icon Back" />
            </div>
          </ButtonBar>
          <LabelBar text={`DISPENSE REPORT: ${reportState.protocolName}`} className="dispensereportheader-labelbar" />
        </HeaderLayout.Left>
        <HeaderLayout.Right>
          <div style={{display: 'flex', gap: 12, paddingRight: 12}}>
            <FmlxButton
              id="button-print"
              label={intl.formatMessage({id: 'dispenseReportHeader.printButton'})}
              onClick={onPrintClick}
              type="basic"
            />
            <FmlxButton
              label={intl.formatMessage({id: 'dispenseReportHeader.saveButton'})}
              onClick={onDownloadClick}
              type="positive"
            />
          </div>
        </HeaderLayout.Right>
      </HeaderLayout>
    );
  }
}

export default connect(mapStateToProps)(DispenseReportHeader);

DispenseReportHeader.propTypes = {
  intl: PropTypes.any.isRequired,
  onBack: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onPrintClick: PropTypes.func.isRequired,
  reportState: PropTypes.object.isRequired,
};
